import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { BambooSecrets_1Screen } from "../BambooSecrets/game_1Screen";
export class BambooSecretsLink_1Screen extends BambooSecrets_1Screen {

        constructor(multigameParams: MultigameParams , initData: SlotGameInitData) {
            super(multigameParams , initData, "BambooSecretsLink");
        }
    }
     
